import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMail = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.33334 4.66675L6.77662 8.47705C7.21731 8.78554 7.43766 8.93978 7.67737 8.99955C7.88913 9.05234 8.11088 9.05234 8.32264 8.99955C8.56235 8.93978 8.7827 8.78554 9.22339 8.47705L14.6667 4.66675M4.53334 13.3334H11.4667C12.5868 13.3334 13.1468 13.3334 13.5747 13.1154C13.951 12.9237 14.257 12.6177 14.4487 12.2414C14.6667 11.8136 14.6667 11.2535 14.6667 10.1334V5.86675C14.6667 4.74664 14.6667 4.18659 14.4487 3.75876C14.257 3.38244 13.951 3.07648 13.5747 2.88473C13.1468 2.66675 12.5868 2.66675 11.4667 2.66675H4.53334C3.41324 2.66675 2.85319 2.66675 2.42535 2.88473C2.04903 3.07648 1.74307 3.38244 1.55132 3.75876C1.33334 4.18659 1.33334 4.74664 1.33334 5.86675V10.1334C1.33334 11.2535 1.33334 11.8136 1.55132 12.2414C1.74307 12.6177 2.04903 12.9237 2.42535 13.1154C2.85319 13.3334 3.41324 13.3334 4.53334 13.3334Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgMail;
